// extracted by mini-css-extract-plugin
module.exports = {"h3":"p7Gp2_","base":"_3e0AgM"};